import UserProfileService from './userProfile.service';
import { queryOptions, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import useUserProfileMutation from './userProfile.mutation';
import useUserMutation from './users.mutation';

interface IUseUserProfile {
  executeUserAction: any;
  isUpdating: any;
  setIsUpdating: any;
  executeUserActionMutation: any;
}

const useUsers = (): IUseUserProfile => {
  const { executeUserAction, isUpdating, setIsUpdating, executeUserActionMutation } = useUserMutation();

  return {
    executeUserAction,
    isUpdating,
    setIsUpdating,
    executeUserActionMutation,
  };
};

export default useUsers;